var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","min-height":"100vh"},attrs:{"id":"app"}},[_c('router-view'),(!_vm.isInAdminRoute && !_vm.isHideFooterPage)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }